<div
  #modalContents
  [class]="lmodalContentsClassWithWidth"
  aria-modal="true"
  role="dialog"
  [attr.aria-labelledby]="'label.in-flightMeal' | staticMsg"
>
  <div #modalHead [class]="lmodalHeaderClass">
    <!-- モーダルヘッダーが入ります -->
    <div class="p-modal-head02">
      <h1 id="meal-application-modal-hedder-title" class="p-modal-head02__title p-modal-head02__title--blue">
        <span [innerHTML]="'label.in-flightMeal' | staticMsg"></span>
        <asw-tooltip
          iconImage="<img src=&quot;assets/images/icon_help_primary_24.svg&quot; alt=&quot;{{
            'm_static_message-alt.helpIcon2' | staticMsg
          }}&quot; width=&quot;20&quot; height=&quot;20&quot;>"
          [tooltipContent]="'tooltip.inflightmeal2' | staticMsg"
          [tooltipTop]="-75"
          [displayAreaClass]="'p-modal-head02'"
        >
        </asw-tooltip>
      </h1>
      <button id="meal-application-modal-h2" class="p-modal-head02__close js-modal-close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
    <!-- //モーダルヘッダーが入ります -->
  </div>

  <div #modalBody [class]="lmodalBodyClass">
    <!-- モーダルの中身が入ります -->
    <div class="p-form-layout04">
      <ng-container *ngFor="let traveler of travelers">
        <ng-container *ngIf="hasMeal(traveler.id)">
          <asw-flight-meal-traveler [traveler]="traveler"></asw-flight-meal-traveler>
        </ng-container>
      </ng-container>
      <div id="serviceRecommendationArea"></div>
    </div>
    <!-- //モーダルの中身が入ります -->
  </div>

  <div #modalFooter [class]="lmodalFooterClass">
    <div class="p-modal-foot01">
      <asw-button
        id="meal-application-modal-footer-buton1"
        type="primary"
        size="s-min-w100"
        [label]="'label.apply.button' | staticMsg"
        [disabled]="isSubmitEnable !== true"
        (click$)="clickSubmit()"
      ></asw-button>
    </div>
  </div>
</div>
